module.exports = __webpack_public_path__ + "img/logo-xero.a3a86ea7.png";